import { t } from "i18next";

export const projects = {
  title: "Gestion des projets",
  form: {
    title: "Titre",
    title_placeholder: "Entrez le titre du projet",
    description: "Description",
    description_placeholder: "Entrez une description",
    startDate: "Date de début",
    endDate: "Date de fin",
    creating: "Création...",
    updating: "Mise à jour...",
    submit: "Créer",
    update: "Mettre à jour",
    create_success: "Projet créé avec succès",
    create_error: "Erreur lors de la création",
    update_success: "Projet mis à jour avec succès",
    update_error: "Erreur lors de la mise à jour",
    supplier: "Fournisseur",
    loading_suppliers: "Chargement fournisseurs",
    select_supplier: "Sélectionner fournisseur",
    collaborator: "Collaborateur",
    loading_users: "Chargement collaborateur",
    select_collaborator: "Sélectionner collaborateur",
  },
  actions: {
    edit: "Modifier",
    delete: "Supprimer",
  },
  header_title: "Liste des projets",
  table: {
    createdAt: "Créé le",
    startDate: "Début",
    endDate: "Fin",
  },
  create_form: {
    title: "Nouveau projet",
  },
};
